import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <p>© {currentYear} Đèn giao thông thông minh. SAIGONIOT V1.1</p>
        </div>
        <div className="footer-section footer-links">
          <a href="#about">Về chúng tôi</a>
          <a href="#contact">Liên hệ</a>
          <a href="#privacy">Chính sách bảo mật</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;